import { c as _c } from "react/compiler-runtime";
import { Badge } from '@onefootprint/ui';
import type { FormattedRegistration } from '../../../../../../onboarding-business-insight.types';
import { EMPTY_VALUE, statusVariant } from '../../../../constants';
import useRegistrationStatusText from '../../../../hooks/use-registration-status-text';
type MobileRowProps = {
  filing: FormattedRegistration;
};
const MobileRow = t0 => {
  const $ = _c(15);
  const {
    filing: t1
  } = t0;
  const {
    state,
    registrationDate,
    status
  } = t1;
  const t = useRegistrationStatusText();
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Object.keys(statusVariant);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const hasStatus = t2.includes(status);
  let t3;
  if ($[1] !== state) {
    t3 = <span className="min-w-0 text-label-2 text-primary wrap-anywhere">{state}</span>;
    $[1] = state;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== hasStatus || $[4] !== status || $[5] !== t) {
    t4 = hasStatus && <Badge className="shrink-0" variant={statusVariant[status]}>{t(status)}</Badge>;
    $[3] = hasStatus;
    $[4] = status;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="flex items-center justify-between gap-3">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== registrationDate) {
    t6 = registrationDate !== EMPTY_VALUE && <span className="text-body-3 text-tertiary">{registrationDate}</span>;
    $[10] = registrationDate;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <td><div className="flex flex-col gap-0.5 py-2 whitespace-normal">{t5}{t6}</div></td>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default MobileRow;